import {
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  hexToRgb,
} from '../../coscef';

const customCircularProgressStyle = (theme) => ({
  root: {
    display: 'block',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
    position: 'inherit',
    height: '100%',
    width: '100%',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  grande: {
    size: 50,
  },
  primary: {
    color: primaryColor[0],
  },
  warning: {
    color: warningColor[0],
  },
  danger: {
    color: dangerColor[0],
  },
  success: {
    color: successColor[0],
  },
  info: {
    color: infoColor[0],
  },
  rose: {
    color: roseColor[0],
  },
  gray: {
    // color: grayColor[0],
    color: grayColor[1],
  },
  primaryBackground: {
    background: 'rgba(' + hexToRgb(primaryColor[0]) + ', 0.2)',
  },
  warningBackground: {
    background: 'rgba(' + hexToRgb(warningColor[0]) + ', 0.2)',
  },
  dangerBackground: {
    background: 'rgba(' + hexToRgb(dangerColor[0]) + ', 0.2)',
  },
  successBackground: {
    background: 'rgba(' + hexToRgb(successColor[0]) + ', 0.2)',
  },
  infoBackground: {
    background: 'rgba(' + hexToRgb(infoColor[0]) + ', 0.2)',
  },
  roseBackground: {
    background: 'rgba(' + hexToRgb(roseColor[0]) + ', 0.2)',
  },
  grayBackground: {
    background: 'rgba(' + hexToRgb(grayColor[6]) + ', 0.2)',
  },
});

export default customCircularProgressStyle;
